import React from 'react';
import { MinimizedModalsType } from '@/types/globals';
import OverwatchModal from '../OverwatchModal';
import ReportPage from '@/pages/ReportPage';
import ReportContextProvider from '@/Contexts/ReportContext/Provider';
import { useSearchParams } from 'react-router';
import { useReactiveVar } from '@apollo/client/react';
import { setOpenedModals } from '@/graphql/reactiveVars';

interface EditReportModalProps {
  minimized: boolean;
  handleClose: () => void;
  handleMinimize?: (label: MinimizedModalsType['label']) => void;
}

const EditReportModal: React.FC<EditReportModalProps> = ({ minimized = false, handleClose }) => {
  const openedModals = useReactiveVar(setOpenedModals);
  const [_, setSearchParams] = useSearchParams();

  return (
    <OverwatchModal
      size="xl"
      handleClose={() => {
        handleClose();
        if (!openedModals.includes('ViewReport')) {
          setSearchParams({});
        }
      }}
      title="Edit Report"
      caption="Edit the details below to update the report"
      primaryButton={<></>}
      secondaryButton={<></>}
      minimized={minimized}
    >
      <ReportContextProvider>
        <ReportPage />
      </ReportContextProvider>
    </OverwatchModal>
  );
};

export default EditReportModal;
